<template>
  <button v-on="$listeners" class="btn" :style="buttonStyles">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
    backgroundColorHover: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    textColorHover: {
      type: String,
      default: '',
    },
    borderColor: {
      type: String,
      default: '',
    },
    borderColorHover: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    padding: {
      type: String,
      default: '',
    },
  },
  computed: {
    buttonStyles() {
      return {
        '--button-background-color': this.backgroundColor,
        '--button-background-color-hover': this.backgroundColorHover,
        '--button-text-color': this.textColor,
        '--button-text-color-hover': this.textColorHover,
        '--button-border-color': this.borderColor,
        '--button-border-color-hover': this.borderColorHover,
        '--button-width': this.width,
        '--button-padding': this.padding,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  padding: var(--button-padding, 10px 30px);
  background-color: var(--button-background-color, #0088db);
  color: var(--button-text-color, #ffffff);
  border: solid 4px var(--button-border-color, transparent);
  width: var(--button-width);
  transition: all 0.4s;

  &:hover {
    background-color: var(--button-background-color-hover, #01598f);
    color: var(--button-text-color-hover, #ffffff);
    border: solid 4px var(--button-border-color-hover, transparent);
  }
}
</style>
